import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import HttpClient from "../network/http";
import { fetchCsrfToken } from "../context/AuthContext";
import ParentEducationService from "../service/parentEducation";

const baseURL = process.env.REACT_APP_BASE_URL;

export default function useParentEducation({ schoolid }) {
  const queryClient = useQueryClient();
  const httpClient = new HttpClient(baseURL, () => fetchCsrfToken());
  const service = new ParentEducationService(httpClient);

  const invalidate = () =>
    queryClient.invalidateQueries({
      queryKey: ["parentEducationBootstrap", schoolid],
    });

  const bootstrapQuery = useQuery(
    ["parentEducationBootstrap", schoolid],
    () => service.getBootstrap({ schoolid }),
    {
      enabled: !!schoolid,
      staleTime: 1000 * 60,
    },
  );

  const createPeriodMutation = useMutation((body) => service.createPeriod(body), {
    onSuccess: invalidate,
  });

  const updatePeriodMutation = useMutation(
    ({ id, body }) => service.updatePeriod(id, body),
    { onSuccess: invalidate },
  );

  const deletePeriodMutation = useMutation((id) => service.deletePeriod(id), {
    onSuccess: invalidate,
  });

  const loadPreviousPeriodsMutation = useMutation((body) =>
    service.loadPreviousPeriods(body),
  );

  const upsertAttendanceBulkMutation = useMutation(
    (body) => service.upsertAttendanceBulk(body),
    { onSuccess: invalidate },
  );

  return {
    bootstrapQuery,
    createPeriodMutation,
    updatePeriodMutation,
    deletePeriodMutation,
    loadPreviousPeriodsMutation,
    upsertAttendanceBulkMutation,
  };
}
